module.exports = __webpack_public_path__ + "img/gift4-01-c10-k1.c401c953.png";